import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { useApp } from "@/context/AppContext";
import { Logo } from "@/components/Logo";
import { PasswordStrength } from "@/components/PasswordStrength";
import api from "@/lib/api";

export default function ResetPassword() {
  const { t } = useApp();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) { toast.error(t("passwordTooShort")); return; }
    if (pw !== pw2) { toast.error(t("passwordsMismatch")); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password: pw });
      toast.success(t("resetSuccess"));
      navigate("/login");
    } catch (err) {
      toast.error(err.response?.data?.detail || t("resetInvalid"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md min-h-[100dvh] flex flex-col justify-center px-6 py-10 sm:border-x-2 sm:border-gray-800" style={{ background: "var(--app-bg)" }}>
      <div className="sb-pop flex flex-col items-center mb-8">
        <Logo className="h-28 mb-4 drop-shadow-xl" />
      </div>
      <div className="sb-card p-6 sb-pop" data-testid="reset-password-card">
        <h2 className="text-xl font-heading font-semibold text-gray-900 mb-4">{t("resetTitle")}</h2>
        {!token ? (
          <p data-testid="reset-no-token" className="font-body text-sm text-red-600">{t("resetInvalid")}</p>
        ) : (
          <form onSubmit={submit} className="space-y-3">
            <input data-testid="reset-password" type="password" className="sb-input" placeholder={t("newPassword")} value={pw} onChange={(e) => setPw(e.target.value)} required />
            <PasswordStrength value={pw} />
            <input data-testid="reset-password-confirm" type="password" className="sb-input" placeholder={t("confirmPassword")} value={pw2} onChange={(e) => setPw2(e.target.value)} required />
            <button data-testid="reset-submit" type="submit" disabled={loading}
              className="sb-btn w-full py-3.5 text-white font-medium text-lg disabled:opacity-60" style={{ background: "var(--app-primary)" }}>
              {loading ? "…" : t("resetSubmit")}
            </button>
          </form>
        )}
        <button data-testid="reset-back-login" onClick={() => navigate("/login")}
          className="mt-5 w-full text-center font-body text-gray-600 underline">{t("backToLogin")}</button>
      </div>
    </div>
  );
}
